import angular from 'angular';
import template from './template.jade';
import './index.less';

import modalCtrl from './modal.ctrl';
import modalTemplate from './modal.jade';
import './modal.less';

import uiModal from '@cian/ui/app/components/modal/index.jsm';
import uiPreloader from '@cian/ui/app/components/preloader/index.jsm';
import uiEmailSubdomainValidator from '@cian/ui/app/components/email-subdomain-validator/index.jsm';

export default angular.module('cian.feedback', [uiModal, uiPreloader, uiEmailSubdomainValidator])
.directive('cianFeedback', () => {
  return {
    scope: {},
    bindToController: {
      title: '@',
      description: '@',
      source: '@',
      email: '@',
      onClick: '&',
      onSuccess: '&',
      onCancel: '&'
    },
    controller: ['$uibModal', function ($uibModal) {
      this.openFeedbackModal = () => {
        this.onClick();

        $uibModal.open({
          animation: true,
          windowClass: 'serp-feedback-modal',
          template: modalTemplate,
          controller: modalCtrl,
          controllerAs: 'modal',
          resolve: {
            title: () => this.title,
            description: () => this.description,
            source: () => this.source,
            email: () => this.email,
          }
        }).result.then(() => this.onSuccess()).catch(() => this.onCancel());
      }
    }],
    controllerAs: '$ctrl',
    template,
    transclude: true
  }
})
.name;



// WEBPACK FOOTER //
// ./src/common/feedback/index.js